module.exports = __webpack_public_path__ + "img/20191023165036360截图20191023154839752.14a77f59.jpg";